import {IMAGE_RESIZE_QUERY_STRING} from "../../config/constants"

const getImagePath = (url: string, itemId?: string, width?: string): string =>
    itemId && width ? `${url.replace("{itemNumber}", itemId)}${IMAGE_RESIZE_QUERY_STRING.replace("{px}", width)}` : url

export default getImagePath
